/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/initialize_map" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postIntegrationsDirectCdiInitializeMapCacheKeys } from "./constants";
import type { PostInitializeCdiMapProps, PostInitializeCdiMapResult } from "./types";

export const postIntegrationsDirectCdiInitializeMap = reactQueryMutationAdapter(
  postIntegrationsDirectCdiInitializeMapCacheKeys,
  (props: PostInitializeCdiMapProps): Promise<PostInitializeCdiMapResult> => {
    return fetch("/integrations/direct/cdi/initialize_map", "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
